import React from 'react';
import {Box} from 'reactjs-admin-lte';
import FontAwsome from 'react-fontawesome';
import {Col, Row} from 'react-bootstrap';

export default ({loading = true, receiving = {}}) => {
  return (<div>
    <Box loading={loading}>
      <Box.Header>
        <Box.Title border={true}>
          <FontAwsome className="text-blue"
                      name="check-square-o" /> รับรถเข้าซ่อม
        </Box.Title>
      </Box.Header>
      <Box.Body>

        {/*Row 1*/}
        <Row className="form-group">
          <Col sm={2}>
            <label className="control-label">วันที่ติดต่อขอเข้าซ่อม</label>
          </Col>
          <Col sm={2}>
            <input className="form-control" disabled
                   value={receiving.contact_date} />
          </Col>
          <Col sm={2}>
            <input className="form-control" disabled
                   value={receiving.contact_time} />
          </Col>
          <Col sm={2}>
            <label
                className="control-label">วันที่นัดรับรถเข้าซ่อมล่วงหน้า</label>
          </Col>
          <Col sm={4}>
            <input className="form-control" disabled
                   value={receiving.advance_date} />
          </Col>
        </Row>


        {/*Row 2*/}
        <Row className="form-group">
          <Col sm={2}>
            <label className="control-label">วันที่รับรถเข้าซ่อม</label>
          </Col>
          <Col sm={2}>
            <input className="form-control" disabled
                   value={receiving.entrance_date} />
          </Col>
          <Col sm={2}>
            <input className="form-control" disabled
                   value={receiving.entrance_time} />
          </Col>
          <Col sm={2}>
            <label
                className="control-label">วันที่อู่นัดส่งมอบรถ
                                          (แสดงในปฏิทิน)</label>
          </Col>
          <Col sm={4}>
            <input className="form-control" disabled
                   value={receiving.appointment_date} />
          </Col>
        </Row>

        {/*Row 3*/}
        <Row className="form-group">
          <Col sm={2}>
            <label className="control-label">ชื่อผู้นำรถเข้าซ่อม</label>
          </Col>
          <Col sm={4}>
            <input className="form-control" disabled
                   value={receiving.entrance_name} />
          </Col>
          <Col sm={2}>
            <label
                className="control-label">จำนวนวันที่คาดว่าจะเสร็จ</label>
          </Col>
          <Col sm={4}>
            <input className="form-control" disabled
                   value={receiving.fixing_day} />
          </Col>
        </Row>

        {/*Row 4*/}
        <Row className="form-group">
          <Col sm={2}>
            <label className="control-label">หมายเลขโทรศัพท์ </label>
          </Col>
          <Col sm={4}>
            <input className="form-control" disabled
                   value={receiving.tel} />
          </Col>
          <Col sm={2}>
            <label
                className="control-label">ชื่อเจ้าหน้าที่ผู้รับรถ</label>
          </Col>
          <Col sm={4}>
            <input className="form-control" disabled
                   value={receiving.receiving_by} />
          </Col>
        </Row>

        {/*Row 5*/}
        <Row className="form-group">
          <Col sm={2}>
            <label className="control-label">ลำดับเรื่อง </label>
          </Col>
          <Col sm={4}>
            <input className="form-control" disabled
                   value={receiving.ref_no} />
          </Col>
          <Col sm={2}>
            <label
                className="control-label">พนักงานอู่ที่เปิดเครื่อง</label>
          </Col>
          <Col sm={4}>
            <input className="form-control" disabled
                   value={receiving.openwork_by} />
          </Col>
        </Row>

        {/*Row 6*/}
        <Row className="form-group">
          <Col sm={2}>
            <label className="control-label">รถจอดซ่อม?</label>
          </Col>
          <Col sm={4}>
            <label className="label-radio">
              <input type="radio" disabled
                     checked={receiving.park_status === 'park'} />
              จอด
            </label>
            <label className="label-radio">
              <input type="radio" disabled
                     checked={receiving.park_status === 'no_park'} />
              ไม่จอด
            </label>
          </Col>
          <Col sm={2}>
            <label
                className="control-label">ผู้รับผิดชอบงาน</label>
          </Col>
          <Col sm={4}>
            <input className="form-control" disabled
                   value={receiving.checking_by} />
          </Col>
        </Row>

        {/*Row 7*/}
        <Row className="form-group">
          <Col sm={2}>
            <label className="control-label">สั่งอะไหล่หรือเปล่า?</label>
          </Col>
          <Col sm={4}>
            <label className="label-radio">
              <input type="radio" disabled
                     checked={receiving.order_part === 'order'} />
              สั่ง
            </label>
            <label className="label-radio">
              <input type="radio" disabled
                     checked={receiving.order_part === 'no_order'} />
              ไม่สั่ง
            </label>
            <label className="label-radio">
              <input type="radio" disabled
                     checked={receiving.order_part === 'waiting'} />
             รอสั่งอะไหล่
            </label>
          </Col>
          <Col sm={2}>
            <label className="control-label">หมายเหตุ</label>
          </Col>
          <Col sm={4}>

            <textarea rows={3} className="form-control" disabled
                      value={receiving.remark} />
          </Col>
        </Row>

        {/*Row 8*/}
        <Row className="form-group">
          <Col sm={2}>
            <label
                className="control-label">ถอดอะไหล่ซ่อม/เทียบ?</label>
          </Col>
          <Col sm={4}>
            <label className="label-radio">
              <input type="radio" disabled
                     checked={receiving.no_park_status === 'taking_spare'} />
              ถอด
            </label>
            <label className="label-radio">
              <input type="radio" disabled
                     checked={receiving.no_park_status === 'no_taking_spare'} />
              ไม่ถอด
            </label>
          </Col>
        </Row>


      </Box.Body>
    </Box>
  </div>);
};


// WEBPACK FOOTER //
// ./src/view/workdoc/preview/components/PreviewReceiver.js